import { Component } from '@angular/core';

@Component({
  selector: 'app-glossario',
  templateUrl: './glossario.component.html',
  styleUrls: ['./glossario.component.scss']
})
export class GlossarioComponent {

}
